"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

require("core-js/modules/es6.regexp.replace");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

require("./search-suggestion.css");

var _searchFunctions = require("../utils/search-functions");

var _constants = require("../constants");

var _helperUtils = require("../utils/helperUtils");

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var SearchSuggestion = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(SearchSuggestion, _React$Component);

  var _super = _createSuper2(SearchSuggestion);

  function SearchSuggestion() {
    var _this;

    (0, _classCallCheck2.default)(this, SearchSuggestion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getTarget", function (_keywords) {
      return _keywords.replace(/ /g, '+');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "doSiteSearch", function () {
      if (typeof window._satellite !== 'undefined') {
        window._satellite.track('commonSearchInteraction', {
          clickedCommonSearchTerm: [_this.props.label]
        });
      }

      if (typeof window !== 'undefined') {
        document.location.href = (0, _searchFunctions.redirectSiteSearch)(_this.props.label);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateCursor", function () {
      _this.props.onMouseEnter(_this.props.index);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetCursor", function () {
      _this.props.onMouseLeave(-1);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSearchSuggestionItemKeyDown", function (e) {
      if ((0, _helperUtils.filterKeyPress)(e, [_helperUtils.keyCodeMap.enter])) {
        _this.doSiteSearch();
      } else {
        _this.props.onKeyDown(e);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(SearchSuggestion, [{
    key: "render",
    value: function render() {
      var index = this.props.index;
      return _react.default.createElement("li", {
        className: "suggestion-item ".concat(this.props.index === this.props.cursor ? 'focus' : ''),
        onMouseDown: this.doSiteSearch,
        onMouseEnter: this.updateCursor,
        onMouseLeave: this.resetCursor,
        onKeyDown: this.onSearchSuggestionItemKeyDown,
        ref: this.myRef
      }, _react.default.createElement("a", {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: "0",
        className: "suggestion-item-text",
        "aria-label": "".concat(_constants.COMMON_SEARCHES, ":").concat(this.props.label) // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        ,
        role: "option",
        id: "option-".concat(index) // onKeyDown={this.props.onKeyDown}
        // {...getLinkTrackingAttr(this.props.label, this.props.index)} // TRNT-2337 : Reverse the link tracking on site search feature

      }, this.props.label));
    }
  }]);
  return SearchSuggestion;
}(_react.default.Component);

exports.default = SearchSuggestion;
(0, _defineProperty2.default)(SearchSuggestion, "propTypes", {
  label: _propTypes.default.string,
  cursor: _propTypes.default.number,
  index: _propTypes.default.number,
  onKeyDown: _propTypes.default.func,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func
});
(0, _defineProperty2.default)(SearchSuggestion, "defaultProps", {
  label: '',
  onKeyDown: function onKeyDown() {}
});